// 格式化直播结束时间
const localDateH = (value) => {
    let date = new Date(value*1000),
    Hour = date.getHours(),
    Minute = date.getMinutes(),
    H = Hour >= 10 ? Hour + ':' : '0' + Hour + ':',
    Mi =  Minute >= 10 ? Minute + ' ' : '0' + Minute + ' '
    return H + Mi
}

export default localDateH;



// WEBPACK FOOTER //
// ./src/utils/localDate.js